exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-category-players-age .tag-element{background-color:#00a97f}.tag-category-number-of-players .tag-element{background-color:#5151a6}.tag-category-operational-goals .tag-element{background-color:#cd975a}.tag-category-thematic-categories .tag-element{background-color:#cd5a77}.tag-column-heading{font-weight:bolder;margin-bottom:20px}.tag-element{padding:2px 5px;display:inline-block;margin-bottom:10px;color:#fff;border-radius:5px}.tag-element a{color:#fff!important}.tag-element a:first-child{margin-left:10px}.tag-element a:last-child{top:-1px;position:relative}.tag-form-heading{font-weight:bolder;margin-bottom:20px}", ""]);

// exports
